import Vue from "vue";
import VueRouter from "vue-router";
import Layout from "../views/layout/index.vue";
import UserCenter from "../views/layout/userCenter.vue";
import mobiles from "./mobile";

Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

function isMobile() {
  var ua = navigator.userAgent
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/),
    isIphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/),
    isAndroid = ua.match(/(Android)\s+([\d.]+)/),
    isMobile = isIphone || isAndroid
  if (isMobile) {
    return true
  }
  return false
}



var ismob = isMobile();

var routes = [
  // {
  //   path: '/micrologin/:number?',
  //   name: 'MicroLogin',
  //   component: () => import('../views/MicroClass/MicroLogin.vue'),
  //   meta: { title: '推荐人登录' },
  // },
  // {
  //   path: '/microlist',
  //   name: 'MicroList',
  //   component: () => import('../views/MicroClass/MicroList.vue'),
  //   meta: { title: '推荐人查询' },
  // },
  {
    path: "/userCenter",
    redirect: { path: "/userCenter/info" },
  },

  {
    path: "/entrance/:id",
    name: "entrance",
    meta: { title: "入口页", icon: "dashboard", auth: "user" },
    component: () => import("../views/papers/entrance.vue"),
  },

  // {
  //   path: '/exam/:id',
  //   name: 'exam',
  //   meta: { title: '考试页', icon: 'dashboard', auth: 'user' },
  //   component: () => import('../views/papers/exam.vue'),
  // },
  {
    path: "/verify/:id",
    name: "verify",
    meta: { title: "认证页", icon: "dashboard", auth: "user" },
    component: () => import("../views/papers/verify.vue"),
  },

  {
    path: "/exam_wp/:id",
    name: "exam_wp",
    meta: { title: "考试页", icon: "dashboard", auth: "user" },
    component: () => import("../views/papers/exam_wp.vue"),
  },
  // {
  //   path: '/examLogin',
  //   name: 'examLogin',
  //   component: () => import('../views/cheat/examLogin.vue'),
  // },
  {
    path: "/examVerify",
    name: "examVerify",
    component: () => import("../views/cheat/examVerify.vue"),
  },

  {
    path: "/userCenter",
    name: "UserCenter",
    component: UserCenter,
    children: [
      {
        path: "/userCenter/:id",
        name: "UserInfo",
        component: () => import("../views/UserCenter.vue"),
        meta: { title: "生涯规划咨询师" },
      },
    ],
  },

  {
    path: "/",
    name: "Home",
    component: Layout,
    children: [
      {
        path: "/",
        name: "Home",
        component: () => import("../views/Home.vue"),
      },
      {
        path: "traincourse",
        name: "Traincourse",
        component: () => import("../views/Traincourse.vue"),
        meta: { title: "培训课程" },
      },

      {
        path: "guide",
        name: "Guide",

        component: () => import("../views/Guide.vue"),
        meta: { title: "生涯规划咨询师" },
      },

      {
        path: "login",
        name: "Login",

        component: () => import("../views/Login.vue"),
        meta: { title: "登录" },
      },
      {
        path: "regist/:agent?",
        name: "Regist",

        component: () => import("../views/Regist.vue"),
        meta: { title: "注册" },
      },
      {
        path: "reset",
        name: "Reset",

        component: () => import("../views/ResetPwd.vue"),
        meta: { title: "重置密码" },
      },

      {
        path: "examination",
        name: "Examination",

        component: () => import("../views/Examination.vue"),
        meta: { title: "生涯规划咨询师" },
      },
      {
        path: "course/:id?",
        name: "Course",

        component: () => import("../views/cheat/course.vue"),
        meta: { title: "生涯规划咨询师" },
      },
      {
        path: "videoplays/:cid/:uid/:id",
        name: "Videoplays",
        component: () => import("../views/cheat/videoplays.vue"),
        meta: { title: "视频播放" },
      },

      {
        path: "certinfo",
        name: "CertInfo",
        component: () => import("../views/CertInfo.vue"),
        meta: { title: "生涯规划咨询师" },
      },
      {
        path: "xy",
        name: "Xy",
        component: () => import("../views/Xy.vue"),
        meta: { title: "平台协议" },
      },
      {
        path: "team",
        name: "Team",
        component: () => import("../views/team.vue"),
        meta: { title: "课程师资" },
      },
    ],
  },
];

if (ismob) {
  routes = mobiles;
}

const router = new VueRouter({
  mode: "hash",
  routes,
});

export default router;
